import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ServicesHero from "./components/ServicesHero";
import ServicesTabs from "./components/ServicesTabs";

export default function ServicesPage() {
  return (
    <div className="bg-[#080808] min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <ServicesHero />
      <ServicesTabs />
      <Footer />
    </div>
  );
}
